<div class="attach-files-component">
    <file-explorer
        class="folder-explorer-component-wrapper"
        [files]="tcFiles"
        (selectedFiles)="onFilesSelected($event)"
    ></file-explorer>
    <div class="attach-file-panel-footer">
        <gsp-button
            [type]="ButtonType.Default"
            text="{{ 'cancel' | translate }}"
            (action)="cancelEditAction()"
        ></gsp-button>
        <gsp-button
            [type]="ButtonType.Primary"
            [disabled]="!isUpdated"
            text="{{ 'Survey.SurveyEditPanel.LinkLabel' | translate }}"
            (action)="attachFiles()"
        ></gsp-button>
    </div>
</div>
